import Swiper, { Scrollbar, Autoplay, Navigation } from 'swiper';

export const testimonialsCarousel = () => {
  const sliders = document.querySelectorAll('.customer-testimonials');
  const testimonialSection = document.querySelector('.customer-testimonial-section');
  const testimonialLayout = testimonialSection?.dataset.testimonialLayout;

  sliders.forEach((slider) => {
    const autoplay = slider.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(slider.dataset.autoplayDelay);

    const swiperOptions = {
      modules: [Scrollbar, Navigation],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100,
      },
      navigation: {
        nextEl: '.customer-testimonial-navigation .swiper-btn-next',
        prevEl: '.customer-testimonial-navigation .swiper-btn-prev',
      },
      speed: 400,
      spaceBetween: 12,
      slidesPerView: 4,
      breakpoints: {
        1536: {
          slidesPerView: testimonialLayout === 'heading-left' ? 2.825 : 4,
          dragSize: 600,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 4,
          dragSize: 600,
          spaceBetween: 32,
        },
        900: {
          slidesPerView: 2.3,
          dragSize: 150,
        },
        600: {
          slidesPerView: 2.3,
          dragSize: 150,
        },
        320: {
          slidesPerView: testimonialLayout === 'heading-left' ? 1.38573 : 1.3,
          dragSize: 150,
          spaceBetween: 16,
        },
      },
    };

    if (autoplay) {
      swiperOptions.modules.push(Autoplay);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    new Swiper(slider, swiperOptions);
  });
};
